import { createSelector } from 'reselect'
import getQualitiesSelector from 'redux/selectors/interactive_video_creation/qualities_selector'
import getPlaybackSpeedsSelector from 'redux/selectors/interactive_video_creation/speeds_selector'

export default createSelector(
	[getQualitiesSelector, getPlaybackSpeedsSelector],
	(videoQualities, videoPlaybackSpeeds) => ({
		videoPlaybackSpeeds,
		videoQualities,
	})
)
